import type { JSX } from 'react';
import type { FeedbackInline, FeedbackPalette, WidgetRatingStyle, WidgetStep } from '../types.js';
import { normalizeRatingStyle } from '../types.js';
import { StarRating } from './ratings/StarRating.js';
import { ThumbsRating } from './ratings/ThumbsRating.js';
import { EmojiRating } from './ratings/EmojiRating.js';
import { NumericRating } from './ratings/NumericRating.js';

interface RatingStepProps {
  palette: FeedbackPalette;
  step: WidgetStep;
  inline: FeedbackInline | null;
  value: number | null;
  onChange: (rating: number) => void;
}

export function RatingStep({ palette, step, inline, value, onChange }: RatingStepProps): JSX.Element {
  const style: WidgetRatingStyle = normalizeRatingStyle(step.ratingStyle ?? inline?.rating);
  switch (style) {
    case 'stars':
      return <StarRating palette={palette} value={value} onChange={onChange} />;
    case 'thumbs':
      return <ThumbsRating palette={palette} value={value} onChange={onChange} />;
    case 'emoji-5':
      return <EmojiRating palette={palette} value={value} onChange={onChange} />;
    case 'number-1-5':
      return (
        <NumericRating
          palette={palette}
          value={value}
          onChange={onChange}
          min={1}
          max={5}
          leftLabel={step.leftLabel}
          rightLabel={step.rightLabel}
        />
      );
    case 'nps-0-10':
      return (
        <NumericRating
          palette={palette}
          value={value}
          onChange={onChange}
          min={0}
          max={10}
          leftLabel={step.leftLabel ?? 'Not likely'}
          rightLabel={step.rightLabel ?? 'Extremely likely'}
          buttonSize="compact"
        />
      );
    default:
      return <StarRating palette={palette} value={value} onChange={onChange} />;
  }
}
